import Cache from './lib/cache'

/**
 *
 * @param API_BASE_URL
 * @param LANGUAGE
 * @param client
 * @param lastModify
 * @return {Promise<*>}
 */
export default function loadAppConfig(API_BASE_URL, LANGUAGE, client, lastModify) {
  async function getTranslation() {
    const cache = Cache.create('getTranslation')
    const cacheLastModify = Cache.create('getTranslationModify')

    const cacheModify = cacheLastModify.get() || 0

    if (cache.exists() && cacheModify >= lastModify) {
      return cache.get()
    }

    const { body: translateObject } = await client
      .execute({
        operationId: 'Localization_filter',
        parameters: { language: LANGUAGE, limit: 1000000 },
      })
      .catch((err) => {
        return {
          body: [],
        }
      })

    const acc = {
      [LANGUAGE]: {},
    }

    let result = {}
    if (translateObject) {
      result = translateObject.reduce((acc, curr) => {
        const key = Object.keys(curr)[0]
        const text = curr[key]
        acc[LANGUAGE][key] = {
          key,
          text,
        }
        return acc
      }, acc)
    }

    cache.set(result)
    cacheLastModify.set(lastModify)

    return result
  }

  return getTranslation()
}
